import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Form } from 'app/components';
import { CaretLeft, UserCircle } from '@phosphor-icons/react';

import { formatDate } from "../../../utils/formatDate";
import { EMAIL_TYPE } from "../../event-create/containers/step-3/constants";

import './style';

const validateEmail = (email) => {
  return email?.match(
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  );
};

const AttendeesForm = (props) => {
  const { } = props;

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const prev = localStorage.getItem('current');

  const { userData } = useSelector((state) => state.app);
  const { primaryEventData, selectedCategory, attendeesDetails } = useSelector(
    (state) => state.primaryBuyerFlow
  );
  const { get_to_know_details } = primaryEventData;

  const checkIsPerTicket = (array) => {
    return array?.some(obj => obj.is_question_per_transaction === false);
  };

  const totalAttendees = checkIsPerTicket(get_to_know_details) ? selectedCategory?.count : 1;
  const [currentAttendee, setCurrentAttendee] = useState(1);
  const [attendeesData, setAttendeesData] = useState(
    attendeesDetails?.length
      ? attendeesDetails
      : Array(totalAttendees).fill(null).map(() => ({}))
  );
  const [errors, setErrors] = useState({});

  useEffect(() => {
    window.scrollTo(0, 0);

    if(Object.keys(primaryEventData).length === 0)
      navigate(-2);
    
  }, [currentAttendee]);

  const handleProceed = () => {
    navigate('/event/checkout');
  };

  const handleBack = () => {
    if (currentAttendee === 1) {
      navigate(-1);
    } else {
      localStorage.setItem("current", currentAttendee - 1);
      setCurrentAttendee(currentAttendee - 1);
    }
  };

  const formatPhoneNumber = (input) => input?.length === 12 && input?.startsWith("91")  ? input.slice(2) : input;

  const validateIndividualConfig = (config, activeAttendeeValue) => {
    let err = {};
    if (config?.isRequired && !activeAttendeeValue?.[config?.id]?.length) err[config.id] = 'This is a required field';
    if (config?.label === 'Phone Number' && config?.isPreset) {
      if (formatPhoneNumber(activeAttendeeValue?.[config?.id])?.length !== 10) {
        err[config.id] = 'Enter a valid phone number';
      }
      // else if (!userData?.isPhoneVerified) {
      //   err[config.id] = 'Phone number not verified';
      // }
    }
    if (config?.type === EMAIL_TYPE) {
      if (config?.showSpecific) {
        if (config?.options?.every((option) => !activeAttendeeValue?.[config?.id]?.includes(option?.value))) {
          const validEmailIds = config?.options?.map((item) => item?.value)?.join(', @');
          err[config.id] = `Only @${validEmailIds} are allowed`;
        }
      } else if (!validateEmail(activeAttendeeValue?.[config?.id])) {
        err[config.id] = 'Enter a valid email id';
      }
    }

    return err;
  };
  
  const validateForm = (formConfig) => {
    const activeAttendeeValue = attendeesData[currentAttendee - 1];
    let err = {};
    formConfig?.forEach((config) => {
      if ((config?.specificTicketType && config?.ticketTypes?.length && config?.ticketTypes?.includes(selectedCategory?.ref_id)) || !config?.specificTicketType) {
        const error = validateIndividualConfig(config, activeAttendeeValue);
        err = { ...err, ...error };
        
        if (config?.conditions?.length) {
          config.conditions.forEach((condition) => {
            if (activeAttendeeValue?.[config?.id]?.includes(condition?.choice)) {
              const conditionErr = validateIndividualConfig([condition?.config], activeAttendeeValue);
              err = { ...err, ...conditionErr };
            }
          });
        }
      }
    });

    return err;
  };
  
  const handleSave = (attendeeNumber) => {
    const error = validateForm(get_to_know_details);
    if (Object.keys(error).length) {
      setErrors(error);
    } else {
      setErrors({});
      
      if (currentAttendee === totalAttendees) {
       console.log(attendeesData);
       localStorage.removeItem("current");
       dispatch({ type: "ATTENDEES_DETAILS:SET", data : attendeesData });
       handleProceed();
      } else {
       localStorage.setItem("current", currentAttendee + 1);
       setCurrentAttendee(currentAttendee + 1);
      }
    }
  };

  const handleFormChange = (newValue, config, wholeConfig) => {
    if (wholeConfig) {
      const updatedData = [...attendeesData];
      updatedData[currentAttendee - 1] = {
        ...updatedData[currentAttendee - 1],
        ...wholeConfig,
      };
      dispatch({ type: "ATTENDEES_DETAILS:SET", data: updatedData });
      setAttendeesData(updatedData);
      return;
    }

    const updatedData = [...attendeesData];
    
    updatedData[currentAttendee - 1] = {
      ...updatedData[currentAttendee - 1], 
      [config.id]: newValue,             
    };
    dispatch({ type: "ATTENDEES_DETAILS:SET", data: updatedData });
    setAttendeesData(updatedData);
  };
  
  return (
    <div className='mt-[70px] h-full md:mt-[100px] hgt md:overflow-y-hidden md:flex md:justify-center md:pt-7 md:bg-grey-5 md:relative'>
      <div className="p-6 flex flex-col gap-9 h-auto relative bg-white md:w-[540px] md:rounded-[20px] md:sha-2 md:static md:pb-[120px]">
        <div className="flex gap-4">
          <div className="p-[7px] sha-1" onClick={handleBack}>
            <CaretLeft size={20.571} />
          </div>
          <div className="flex flex-col gap-[2px]">
            <h1 className="heading-16">{primaryEventData?.name}</h1>
            <p className="label-14 text-grey-70">{formatDate(primaryEventData?.start_date)}</p>
          </div>
        </div>

        <h1 className='heading-16'>{currentAttendee === 1 ? 'Primary Booker' : `Attendee ${currentAttendee} details`}</h1>

        <div className="flex flex-col gap-6 h-auto">
          {attendeesData.map((attendee, index) => (
            index + 1 === currentAttendee && (
              <Form
                key={index}
                formConfig={get_to_know_details}
                value={attendeesData[index]}
                onFormChange={handleFormChange}
                errors={errors}
                setErrors={setErrors}
                disabled={index === 0}
                attendeesData={attendeesData}
                ticketCategory={selectedCategory}
              />
            )
          ))}
        </div>
      </div>

      <div className="w-full mt-auto p-6 flex gap-3 items-center border-t-[#FFF2F2] border-t border-solid bg-[#FDFDFD] 
        md:gap-16 md:justify-center">
        <div className='wdh flex gap-7 md:gap-16'>
          <div className="flex gap-2 items-center justify-center">
            <UserCircle size={24} color='#878787' weight='fill' />
            <div className="label-14">{`${currentAttendee}/${totalAttendees}`}</div>
          </div>
          
          <Button className="w-full" 
            onClick={()=>handleSave(currentAttendee+1)}>
            Next
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AttendeesForm;
